<template>
    <div class="drop-file-overlay" @drop="dropHandler($event)" @dragover="dragOverHandler($event)">
        <button class="close-overlay" @click.stop="closeUploadOverlay()">
            <i class="fas fa-times"></i>
        </button>
        <p><i class="fas fa-file-upload"></i><br>Rilascia i file per iniziare il caricamento</p>
    </div>
</template>

<script>
export default {
    name: 'dragAndDropUpload',
    props: {
        closeCb: Function
    },
    methods:{
        dropHandler (ev) {
            let i = 0
            let attachments = []
            // Prevent default behavior (Prevent file from being opened)
            ev.preventDefault()

            if (ev.dataTransfer.items) {
                // Use DataTransferItemList interface to access the file(s)
                for (i = 0; i < ev.dataTransfer.items.length; i++) {
                    // If dropped items aren't files, reject them
                    if (ev.dataTransfer.items[i].kind === 'file') {
                        let file = ev.dataTransfer.items[i].getAsFile()
                        attachments.push(file)
                    }
                }
            } else {
                // Use DataTransfer interface to access the file(s)
                for (i = 0; i < ev.dataTransfer.files.length; i++) {
                    attachments.push(ev.dataTransfer.files)
                }
            }
            this.closeCb()
            this.$root.$emit('selecting_files', attachments)
        },
        dragOverHandler (ev) {
            // Prevent default behavior (Prevent file from being opened)
            ev.preventDefault()
        },
        closeUploadOverlay () {
            this.closeCb()
        }
    }
};
</script>

<style lang="scss">
.drop-file-overlay{
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 99999999;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
    p{
        text-align: center;
        color: white;
        font-size: 1.2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        i{
            font-size: 4rem;
            padding-bottom: 28px;
        }
    }
    .close-overlay{
        position: absolute;
        top: 14px;
        right: 14px;
        color: white;
        font-size: 2rem;
        border: 0px;
        background-color: transparent;
    }
}
</style>